import * as React from 'react';
import { HeroBannerSingleCTA, HeroBannerSingleCTAData, HeroBannerSingleCTAKind } from './HeroBannerSingleCTA';
import { transformDYTemplateVariables } from './utils';
import { DYCustomizableText } from '../types';

export interface DYHeroBannerSingleCTAProps {
  onClick: VoidFunction;
  data: Omit<HeroBannerSingleCTAData, 'title' | 'subtitle' | 'kind'> & {
    title: DYCustomizableText;
    subtitle: DYCustomizableText;
  };
}

export const DYHeroBannerSingleCTA: React.FC<DYHeroBannerSingleCTAProps> = ({ data, onClick }) => {
  if (!data) {
    return <></>;
  }

  const props = transformDYTemplateVariables(data, HeroBannerSingleCTAKind.OutsideGrid);
  return <HeroBannerSingleCTA {...props} onClick={onClick} />;
};
